import React, { useState } from "react";
import {
  FiGrid,
  FiUsers,
  FiBriefcase,
  FiBarChart2,
  FiSettings,
  FiChevronDown,
  FiTag,
  FiLayers,
  FiBox,
  FiLock,
  FiLogOut,
  FiGift,
  FiCpu,
  FiCrop,
  FiUser,
} from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Swal from "sweetalert2";

const Sidebar = ({ isMobileOpen, setIsMobileOpen }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const [productOpen, setProductOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out of the system",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Logout",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc2626",
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
        Swal.fire({
          title: "Logged out",
          text: "You have been logged out successfully",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        navigate("/");
      }
    });
  };

  const mainMenu = [
    { name: "Dashboard", icon: <FiGrid />, path: "/dashboard" },
    { name: "Sales Agent", icon: <FiUsers />, path: "/sales-agents" },
    { name: "Customers", icon: <FiBriefcase />, path: "/customers" },
    { name: "Orders", icon: <FiGift />, path: "/orders" },
    { name: "Referrals", icon: <FiUser />, path: "/referrals" },
  ];

  const productMenu = [
    { name: "Brands", icon: <FiCpu />, path: "/products/brands" },
    { name: "Categories", icon: <FiTag />, path: "/products/categories" },
    { name: "Sub-Categories", icon: <FiLayers />, path: "/products/sub-categories" },
    { name: "Products", icon: <FiBox />, path: "/products/products" },
    { name:"Sizes",icon:<FiCrop />,path:"/products/sizes"}
  ];

  return (
    <>
      {isMobileOpen && (
        <div
          onClick={() => setIsMobileOpen(false)}
          className="fixed inset-0 bg-black/40 z-30 md:hidden"
        />
      )}

      <div
        className={`fixed top-0 left-0 h-screen w-64 bg-white shadow-sm z-40 flex flex-col
        ${isMobileOpen ? "" : "hidden md:flex"}`}
      >
        <div className="px-4 py-4 flex items-center justify-between">
          <div>
            <h1 className="text-lg font-bold text-blue-700">Adana</h1>
            <p className="text-xs text-gray-500">Admin Dashboard</p>
          </div>
          <div>
           <img src="/adana.jpeg" alt="Adana Logo"className="h-16 w-16 object-contain"/>
          </div> 
        </div>

        <div className="mt-4 space-y-1 px-1">
          {mainMenu.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 mx-2 rounded-lg transition
                ${
                  pathname === item.path
                    ? "bg-blue-50 text-blue-700 font-semibold"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
            >
              <span className="text-lg">{item.icon}</span>
              <span>{item.name}</span>
            </Link>
          ))}

          <button
            onClick={() => setProductOpen(!productOpen)}
            className="flex items-center gap-3 px-4 py-3 mx-2 rounded-lg text-gray-600 hover:bg-gray-100 transition w-full"
          >
            <FiBarChart2 className="text-lg" />
            <span className="flex-1 text-left">Product Section</span>
            <FiChevronDown
              className={`transition-transform ${
                productOpen ? "rotate-180" : ""
              }`}
            />
          </button>

          {productOpen && (
            <div className="ml-10 mt-1 space-y-1">
              {productMenu.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm transition
                    ${
                      pathname === item.path
                        ? "bg-blue-50 text-blue-700 font-medium"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                >
                  {item.icon}
                  <span>{item.name}</span>
                </Link>
              ))}
            </div>
          )}

          <button
            onClick={() => setSettingsOpen(!settingsOpen)}
            className="flex items-center gap-3 px-4 py-3 mx-2 rounded-lg text-gray-600 hover:bg-gray-100 transition w-full"
          >
            <FiSettings className="text-lg" />
            <span className="flex-1 text-left">Settings</span>
            <FiChevronDown
              className={`transition-transform ${
                settingsOpen ? "rotate-180" : ""
              }`}
            />
          </button>

          {settingsOpen && (
            <div className="ml-10 mt-1 space-y-1">
              <Link
                to="/change-password"
                className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-gray-600 hover:bg-gray-100"
              >
                <FiLock /> Change Password
              </Link>

              <button
                onClick={handleLogout}
                className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-red-600 hover:bg-red-50 w-full"
              >
                <FiLogOut /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
